// src/pages/Pricing.jsx
import { React, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Login from "../components/Login"; // ← path adjust કરો જો જરૂર હોય

const packages = [
  {
    title: "Package 1",
    plan: "Monthly Subscription",
    price: "₹1333 / month",
    features: [
      "Workout from Home or anywhere in the World",
      "Ads-free Health & Wellness Videos",
      "For more info email or WhatsApp",
    ],
    optional: [
      { label: "PERSONALIZED DIET PLAN – ₹900 [Optional]", amount: 900 },
      {
        label: "3 MONTHS DAILY DIETICIAN ASSISTANCE – ₹5100 [Optional]",
        amount: 5100,
        details: [
          "Meal plate pictures assessment",
          "Weekly Weight Assessment",
          "Blood Reports & Health Check-up assessment",
          "Supplement Guidance",
          "30 mins Weekly Zoom call Consultation",
        ],
      },
    ],
  },
  {
    title: "Package 2",
    plan: "3 Months Subscription",
    price: "₹1999 / month",
    popular: true,
    features: [
      "Workout from Home or anywhere in the World",
      "Ads-free Health & Wellness Videos",
      "For more info email or WhatsApp",
    ],
    optional: [
      { label: "PERSONALIZED DIET PLAN – ₹800 [Optional]", amount: 800 },
      {
        label: "3 MONTHS DAILY DIETICIAN ASSISTANCE – ₹5100 [Optional]",
        amount: 5100,
        details: [
          "Meal plate pictures assessment",
          "Weekly Weight Assessment",
          "Blood Reports & Health Check-up assessment",
          "Supplement Guidance",
          "30 mins Weekly Zoom call Consultation",
        ],
      },
    ],
  },
  {
    title: "Package 3",
    plan: "6 Months Subscription",
    price: "₹3700",
    features: [
      "Workout from Home or anywhere in the World",
      "Ads-free Health & Wellness Videos",
      "For more info email or WhatsApp",
    ],
    optional: [
      { label: "PERSONALIZED DIET PLAN – ₹800 [Optional]", amount: 800 },
      {
        label: "3 MONTHS DAILY DIETICIAN ASSISTANCE – ₹5100 [Optional]",
        amount: 5100,
        details: [
          "Meal plate pictures assessment",
          "Weekly Weight Assessment",
          "Blood Reports & Health Check-up assessment",
          "Supplement Guidance",
          "30 mins Weekly Zoom call Consultation",
        ],
      },
    ],
  },
  {
    title: "Package 4",
    plan: "Annual Subscription",
    price: "₹5500",
    features: [
      "Workout from Home or anywhere in the World",
      "Ads-free Health & Wellness Videos",
      "For more info email or WhatsApp",
    ],
    optional: [
      { label: "PERSONALIZED DIET PLAN – ₹900 [Optional]", amount: 900 },
      {
        label: "3 MONTHS DAILY DIETICIAN ASSISTANCE – ₹5100 [Optional]",
        amount: 5100,
        details: [
          "Meal plate pictures assessment",
          "Weekly Weight Assessment",
          "Blood Reports & Health Check-up assessment",
          "Supplement Guidance",
          "30 mins Weekly Zoom call Consultation",
        ],
      },
    ],
  },
];

const Pricing = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoginOpen, setIsLoginOpen] = useState(false);

  const queryParams = new URLSearchParams(location.search);
  const planAmount = queryParams.get("plan");

  const selectedPlan = planAmount
    ? packages.find((pkg) => pkg.price.replace(/[^0-9]/g, "") === planAmount)
    : null;

  const handleGetStarted = () => {
    setIsLoginOpen(true);
  };

  // If user selected a plan
  if (selectedPlan) {
    return (
      <section className="py-20 px-6 lg:px-20   bg-gray-50">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 max-w-6xl mx-auto">
          {/* Left - Plan Info */}
          <div className="bg-white rounded-2xl shadow-md p-8">
            <h2 className="text-2xl font-bold text-gray-900">
              {selectedPlan.title}
            </h2>
            <p className="text-lg text-gray-600">{selectedPlan.plan}</p>
            <p className="text-3xl text-green-600 font-extrabold mt-4">
              {selectedPlan.price}
            </p>

            {/* Features */}
            <ul className="mt-6 space-y-2 text-gray-700 text-sm">
              {selectedPlan.features.map((f, i) => (
                <li key={i} className="flex items-start">
                  <span className="text-green-600 mr-2">✓</span> {f}
                </li>
              ))}
            </ul>

            {/* Optional Add-ons */}
            {selectedPlan.optional && (
              <>
                <hr className="mt-6 border-gray-200" />
                <div className="mt-4 space-y-4">
                  {selectedPlan.optional.map((opt, i) => (
                    <div key={i} className="text-sm text-gray-600">
                      <p className="flex items-start font-medium">
                        <span className="text-orange-500 mr-2">○</span>
                        {opt.label}
                      </p>
                      {opt.details && (
                        <ul className="mt-2 ml-6 list-disc text-gray-500 text-xs space-y-1">
                          {opt.details.map((d, idx) => (
                            <li key={idx}>{d}</li>
                          ))}
                        </ul>
                      )}
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>

          {/* Right - Form */}
          <div className="bg-white rounded-2xl shadow-md p-8">
            <h3 className="text-xl font-semibold mb-6">
              Complete Your Details
            </h3>
            <form className="space-y-5">
              {["Name", "Phone Number", "Email"].map((label, i) => (
                <div key={i}>
                  <label className="block text-sm font-medium text-gray-700">
                    {label}
                  </label>
                  <input
                    type={
                      label === "Email"
                        ? "email"
                        : label === "Phone Number"
                          ? "tel"
                          : "text"
                    }
                    placeholder={`Enter your ${label.toLowerCase()}`}
                    className="mt-1 w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-green-500"
                  />
                </div>
              ))}

              <button
                type="submit"
                className="w-full bg-green-500 text-white py-3 rounded-lg font-semibold hover:bg-green-600"
              >
                Submit
              </button>
            </form>
          </div>
        </div>
      </section>
    );
  }

  // Default pricing page (all plans)
  return (
    <>
      {/* ✅ Login Modal */}
      <Login
        isOpen={isLoginOpen}
        onClose={() => setIsLoginOpen(false)}
        onOpenRegister={() => setIsLoginOpen(false)}
      />

      <section className="py-20 px-6 lg:px-20 bg-gradient-to-b from-gray-50 to-white">
        <div className="text-center mb-16">
          <h4 className="text-green-600 font-semibold uppercase tracking-wide">
            Pricing
          </h4>
          <h2 className="text-4xl lg:text-5xl font-extrabold text-gray-900 mt-3">
            Choose Your Plan
          </h2>
          <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto">
            Flexible plans designed for every fitness journey. Invest in
            yourself today!
          </p>
        </div>

        {/* Pricing Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {packages.map((pkg, index) => (
            <div
              key={index}
              className={`relative bg-white rounded-2xl shadow-md hover:shadow-2xl transition transform hover:-translate-y-2 p-8 flex flex-col justify-between border ${
                pkg.popular
                  ? "border-green-500 ring-2 ring-green-400"
                  : "border-gray-200"
              }`}
            >
              {pkg.popular && (
                <span className="absolute -top-4 left-1/2 -translate-x-1/2 bg-green-500 text-white text-xs font-semibold px-4 py-1 rounded-full shadow">
                  Most Popular
                </span>
              )}

              <div>
                <h3 className="text-xl font-semibold text-gray-900">
                  {pkg.plan}
                </h3>
                <p className="text-3xl font-bold text-green-600 mt-4">
                  {pkg.price}
                </p>

                <ul className="mt-6 space-y-2 text-gray-700 text-sm">
                  {pkg.features.map((f, i) => (
                    <li key={i} className="flex items-start">
                      <span className="text-green-600 mr-2">✓</span> {f}
                    </li>
                  ))}
                </ul>

                <hr className="mt-6 border-gray-200" />
                <div className="mt-4 space-y-3 text-gray-500 text-sm italic">
                  {pkg.optional.map((opt, i) => (
                    <div key={i}>
                      <p>○ {opt.label}</p>
                      {opt.details && (
                        <ul className="ml-5 mt-1 list-disc text-xs space-y-1">
                          {opt.details.map((d, idx) => (
                            <li key={idx}>{d}</li>
                          ))}
                        </ul>
                      )}
                    </div>
                  ))}
                </div>
              </div>

              <button
                onClick={() => handleGetStarted(pkg)}
                className={`mt-8 w-full py-3 rounded-xl font-semibold transition transform hover:scale-105 shadow-md ${
                  pkg.popular
                    ? "bg-green-500 text-white hover:bg-green-600"
                    : "bg-gray-800 text-white hover:bg-gray-900"
                }`}
              >
                Start with {pkg.title}
              </button>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default Pricing;